import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-forbidden-page',
  standalone: true,
  imports: [ButtonModule, TranslocoModule],
  templateUrl: './forbidden-page.component.html',
  styleUrl: './forbidden-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForbiddenPageComponent {
  private readonly router = inject(Router);
  
  goHome(): void {
    this.router.navigateByUrl('/');
  }
}
